import React, { useState, useEffect } from "react";

function ClassCreator() {
  const [classId, setClassId] = useState("");
  const [className, setClassName] = useState("");
  const [description, setDescription] = useState("");
  const [features, setFeatures] = useState([]);
  const [values, setValues] = useState([]);
  const [units, setUnits] = useState([]);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFeatureModal, setShowFeatureModal] = useState(false);
  const [activeFeature, setActiveFeature] = useState(null);
  const [editFeatureData, setEditFeatureData] = useState({});
  const [showValueModal, setShowValueModal] = useState(false);
  const [showUnitModal, setShowUnitModal] = useState(false);
  const [selectedValueIds, setSelectedValueIds] = useState([]);
  const [valueSearchTerm, setValueSearchTerm] = useState("");
  const [unitSearchTerm, setUnitSearchTerm] = useState("");
  const itemsPerPage = 10;
  const valuesPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [valuePage, setValuePage] = useState(1);

  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const fRes = await fetch("http://localhost:5000/featuress");
      const vRes = await fetch("http://localhost:5000/values");
      const uRes = await fetch("http://localhost:5000/units");
      const fData = await fRes.json();
      const vData = await vRes.json();
      const uData = await uRes.json();
      setFeatures(fData || []);
      setValues(vData || []);
      setUnits(uData || []);
    };
    fetchData();
  }, []);

  const filteredFeatures = features.filter(
    (f) =>
      (f.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        f.featureId?.toLowerCase().includes(searchTerm.toLowerCase())) &&
      !selectedFeatures.some((sf) => sf.featureId === f.featureId)
  );

  const totalPages = Math.ceil(filteredFeatures.length / itemsPerPage);
  const paginatedFeatures = filteredFeatures.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const addFeatureByObject = (feature) => {
    setSelectedFeatures([
      ...selectedFeatures,
      {
        ...feature,
        values: [],
        unit: "",
        active: true,
        selectable: false,
        selectableOrder: null,
      },
    ]);
  };

  const removeFeature = (id) => {
    setSelectedFeatures(selectedFeatures.filter((f) => f.featureId !== id));
  };

  const toggleSelectable = (id) => {
    const updated = selectedFeatures.map((f) =>
      f.featureId === id
        ? {
            ...f,
            selectable: !f.selectable,
            selectableOrder: !f.selectable ? null : f.selectableOrder,
          }
        : f
    );
    setSelectedFeatures(updated);
  };

  const toggleActive = (id) => {
    const updated = selectedFeatures.map((f) =>
      f.featureId === id ? { ...f, active: !f.active } : f
    );
    setSelectedFeatures(updated);
  };

  const changeSelectableOrder = (id, order) => {
    const updated = selectedFeatures.map((f) =>
      f.featureId === id ? { ...f, selectableOrder: Number(order) } : f
    );
    setSelectedFeatures(updated);
  };

  const usedOrders = selectedFeatures
    .filter((f) => f.selectable && f.selectableOrder !== null)
    .map((f) => f.selectableOrder);

  const availableOrders = [1, 2, 3, 4, 5];

  const openFeatureModal = (feature) => {
    setActiveFeature(feature);
    setEditFeatureData({ ...feature });
    setShowFeatureModal(true);
  };

  const saveFeatureEdit = async () => {
    try {
      const res = await fetch(`http://localhost:5000/features/${editFeatureData.featureId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editFeatureData),
      });
      await res.json();
      alert("Feature sparad i Occtoo!");
      setShowFeatureModal(false);
    } catch (error) {
      console.error("Fel vid uppdatering:", error);
    }
  };

  const openValueModal = (feature) => {
    setActiveFeature(feature);
    setSelectedValueIds(feature.values || []);
    setShowValueModal(true);
    setValuePage(1);
  };

  const openUnitModal = (feature) => {
    setActiveFeature(feature);
    setShowUnitModal(true);
  };

  const saveValuesToFeature = () => {
    const updated = selectedFeatures.map((f) =>
      f.featureId === activeFeature.featureId ? { ...f, values: [...selectedValueIds] } : f
    );
    setSelectedFeatures(updated);
    setShowValueModal(false);
    setSelectedValueIds([]);
  };

  const setUnitForFeature = (unitId) => {
    const updated = selectedFeatures.map((f) =>
      f.featureId === activeFeature.featureId ? { ...f, unit: unitId } : f
    );
    setSelectedFeatures(updated);
    setShowUnitModal(false);
  };

  const saveClass = async () => {
    if (!classId) {
      alert("Ange Klass-ID innan du sparar!");
      return;
    }
    const newClass = {
      classId,
      className,
      description,
      features: selectedFeatures.map((f) => ({
        uniqueId: `${classId}_${f.featureId}`,
        featureId: f.featureId,
        classId,
        type: f.type,
        active: f.active,
        values: f.values,
        unit: f.unit || "",
        selectable: f.selectable,
        selectableOrder: f.selectableOrder,
      })),
    };

    await fetch("http://localhost:5000/classes", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newClass),
    });
    alert("Klass sparad!");
  };

  const filteredValues = values.filter((v) =>
    v.displayName.toLowerCase().includes(valueSearchTerm.toLowerCase())
  );
  const totalValuePages = Math.ceil(filteredValues.length / valuesPerPage);
  const paginatedValues = filteredValues.slice(
    (valuePage - 1) * valuesPerPage,
    valuePage * valuesPerPage
  );

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Skapa Klass</h2>
      <div className="mb-3">
        <input
          className="form-control mb-2"
          placeholder="Klass-ID (ex. EC000001)"
          value={classId}
          onChange={(e) => setClassId(e.target.value)}
        />
        <input
          className="form-control mb-2"
          placeholder="Klassnamn"
          value={className}
          onChange={(e) => setClassName(e.target.value)}
        />
        <input
          className="form-control"
          placeholder="Beskrivning"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>

      {/* Valda Features */}
      <h5>Valda Features</h5>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Namn</th>
            <th>Symbol</th>
            <th>Typ</th>
            <th>Selectable</th>
            <th>Order</th>
            <th>Valda värden</th>
            <th>Enhet</th>
            <th>Aktiv</th>
            <th>Åtgärder</th>
          </tr>
        </thead>
        <tbody>
          {selectedFeatures.map((f) => (
            <tr key={f.featureId} className={!f.active ? "table-secondary" : ""}>
              <td>{f.featureId}</td>
              <td>{f.name}</td>
              <td>
                {f.image && (
                  <img
                    src={f.image}
                    alt=""
                    style={{ width: "30px", cursor: "pointer" }}
                    onClick={() => {
                      setActiveImage(f.image);
                      setShowImageModal(true);
                    }}
                  />
                )}
              </td>

              <td>{f.type}</td>
              <td>
                <input
                  type="checkbox"
                  checked={f.selectable}
                  onChange={() => toggleSelectable(f.featureId)}
                />
              </td>
              <td>
                {f.selectable && (
                  <select
                    className="form-select form-select-sm"
                    value={f.selectableOrder || ""}
                    onChange={(e) => changeSelectableOrder(f.featureId, e.target.value)}
                  >
                    <option value="">Välj</option>
                    {availableOrders.map((order) => (
                      <option
                        key={order}
                        value={order}
                        disabled={usedOrders.includes(order) && f.selectableOrder !== order}
                      >
                        {order}
                      </option>
                    ))}
                  </select>
                )}
              </td>
              <td>
                {f.type === "A" && f.values.length > 0
                  ? f.values
                      .map((id) => {
                        const val = values.find((v) => v.valueCode === id);
                        return val ? val.displayName : "";
                      })
                      .join(", ")
                  : "-"}
              </td>
              <td>
                {f.unit
                  ? (() => {
                      const u = units.find((u) => u.unitId === f.unit);
                      return u ? u.unit : "";
                    })()
                  : "-"}
              </td>
              <td>
                <button
                  className={`btn btn-sm ${f.active ? "btn-success" : "btn-secondary"}`}
                  onClick={() => toggleActive(f.featureId)}
                >
                  {f.active ? "Aktiv" : "Inaktiv"}
                </button>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-danger me-1"
                  onClick={() => removeFeature(f.featureId)}
                >
                  Ta bort
                </button>
                {f.type === "A" && (
                  <button
                    className="btn btn-sm btn-secondary me-1"
                    onClick={() => openValueModal(f)}
                  >
                    Värden
                  </button>
                )}
                {(f.type === "N" || f.type === "R") && (
                  <button className="btn btn-sm btn-secondary" onClick={() => openUnitModal(f)}>
                    Enhet
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mb-4">
        <button className="btn btn-success" onClick={saveClass}>
          Skapa ny Klass
        </button>
      </div>
      {/* Sök och lägg till Features */}
      <h5>Sök och lägg till Features</h5>
      <input
        className="form-control mb-2"
        placeholder="Sök Feature"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <table className="table table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>Namn</th>
            <th>Symbol</th>
            <th>Typ</th>
            <th>Beskrivning</th>
            <th>Åtgärd</th>
          </tr>
        </thead>
        <tbody>
          {paginatedFeatures.map((f) => (
            <tr key={f.featureId}>
              <td>{f.featureId}</td>
              <td onClick={() => openFeatureModal(f)} style={{ cursor: "pointer" }}>
                {f.name}
              </td>
              <td>
                {f.image && (
                  <img
                    src={f.image}
                    alt=""
                    style={{ width: "30px", cursor: "pointer" }}
                    onClick={() => {
                      setActiveImage(f.image);
                      setShowImageModal(true);
                    }}
                  />
                )}
              </td>
              <td>{f.type}</td>
              <td>{f.description || "-"}</td>
              <td>
                <button className="btn btn-sm btn-dark" onClick={() => addFeatureByObject(f)}>
                  Lägg till
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <nav className="mt-3">
        <ul className="pagination">
          {[...Array(totalPages)].map((_, i) => (
            <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                {i + 1}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Modal för att redigera featuren */}
      {showFeatureModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Redigera Feature: {activeFeature?.name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFeatureModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  placeholder="Namn"
                  value={editFeatureData.name || ""}
                  onChange={(e) => setEditFeatureData({ ...editFeatureData, name: e.target.value })}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Beskrivning"
                  value={editFeatureData.description || ""}
                  onChange={(e) =>
                    setEditFeatureData({ ...editFeatureData, description: e.target.value })
                  }
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFeatureModal(false)}>
                  Avbryt
                </button>
                <button className="btn btn-dark" onClick={saveFeatureEdit}>
                  Spara Feature
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal för värden */}
      {showValueModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Välj värden för {activeFeature?.name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowValueModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                <input
                  className="form-control mb-3"
                  placeholder="Sök värde"
                  value={valueSearchTerm}
                  onChange={(e) => setValueSearchTerm(e.target.value)}
                />
                <div className="row">
                  {paginatedValues.map((v) => (
                    <div key={v.valueCode} className="col-md-6 mb-2">
                      <div className="card p-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={v.valueCode}
                            checked={selectedValueIds.includes(v.valueCode)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectedValueIds((prev) =>
                                checked
                                  ? [...prev, v.valueCode]
                                  : prev.filter((id) => id !== v.valueCode)
                              );
                            }}
                          />
                          <label className="form-check-label">
                            <strong>{v.displayName}</strong>
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <nav className="mt-3">
                <ul className="pagination justify-content-center">
                  {[...Array(totalValuePages)].map((_, i) => (
                    <li key={i} className={`page-item ${valuePage === i + 1 ? "active" : ""}`}>
                      <button className="page-link" onClick={() => setValuePage(i + 1)}>
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowValueModal(false)}>
                  Avbryt
                </button>
                <button className="btn btn-dark" onClick={saveValuesToFeature}>
                  Spara
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal för enheter */}
      {showUnitModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Välj enhet för {activeFeature?.name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowUnitModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                <input
                  className="form-control mb-3"
                  placeholder="Sök enhet"
                  value={unitSearchTerm}
                  onChange={(e) => setUnitSearchTerm(e.target.value)}
                />
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Enhet</th>
                      <th>Åtgärd</th>
                    </tr>
                  </thead>
                  <tbody>
                    {units
                      .filter((u) => u.unit.toLowerCase().includes(unitSearchTerm.toLowerCase()))
                      .map((u) => (
                        <tr key={u.unitId}>
                          <td>{u.unit}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-dark"
                              onClick={() => setUnitForFeature(u.unitId)}
                            >
                              Välj
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImageModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Symbol</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowImageModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <img src={activeImage} alt="Feature" style={{ maxWidth: "100%" }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClassCreator;
